export const menu = {
  title: "Menu",
  description: "All pages, your account and legal info.",
  signInUp: "Sign in or create an account",
  explore: "Explore",
  myPages: "My pages",
  myOverview: "My overview",
  myAds: "My listings",
  myItems: "My items",
  new: "New",
  myDeals: "My orders",
  myBids: "My bids",
  saved: "Saved listings",
  watchlist: "Watchlist",
  stats: "Statistics",
  account: "Account",
  myProfile: "My profile",
  myAddresses: "My addresses",
  myAccount: "My account",
  myCases: "My cases",
  about: "About Sellavo",
  languageCountry: "Language & country",
  appearance: "Appearance",
  themeAuto: "Follow the sun",
  themeLight: "Light",
  themeDark: "Dark",
  legal: "Legal & cookies",
  admin: "Admin",
  administration: "Administration",
  signOut: "Sign out",
};
